import React from "react";
import Image from "next/image";
import MbbsForm from "@/components/forms/MbbsForm";

const DoctorBannerMobile = () => {
  return (
    <>
      <div className="w-full mt-10">
        <div className="px-0 relative">
          <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 z-20 relative">
            <div className="flex justify-between flex-wrap 2xl:items-center items-center p-4">
              <div className="md:pt-5 pb-[0px] w-full md:pb-16 relative md:top-[120px] mt-0 md:ml-[70px]">
                <div className="text-center relative pb-[13px]">
                  <div className="flex justify-center items-center">
                    <p className="text-[#fff] font-base font-medium text-center leading-[1.2] text-[16px]">
                      Scored 144+ in{" "}
                      <span className="text-[#FFBA08]">NEET UG?</span>
                    </p>
                    <Image
                      src="/healthcare/doctors/new-mob/stars-small.png"
                      alt="stars"
                      className="absolute left-[76px] top-[-16px]"
                      width={20}
                      height={20}
                      loading="eager"
                      fetchPriority="high"
                    />
                  </div>
                  <div className="flex flex-col gap-2 justify-center h-[auto] mt-2">
                    <h1 className="text-white text-center text-[28px] font-semibold leading-[28px]">
                      Study MBBS-MD in America
                    </h1>
                    <h2 className="text-[#FFBA08] text-[30px] leading-[100%] font-bold">
                      Be a Licensed Doctor in the USA
                    </h2>
                    <ul className="leading-[1.3] text-[#fff] text-[14px] tracking-[-0.96px] list-disc list-inside marker:text-[#1772ea] pt-2">
                      <li className="">
                        Clinicals & Residency at Top U.S. Hospitals
                      </li>
                      <li>
                        Earn 2 Crores+ per year (~$250K+) <br />
                        (10x salary with merely 50% fees of
                        <br /> private Indian MBBS-MD)
                      </li>
                    </ul>
                  </div>
                  <div className="shadow-[0px_2px_6px_0px_rgba(51,153,255,0.5)] mb-4 mt-4">
                    <MbbsForm submitButtonName="Speak with an expert" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="rounded-[112px] bg-gradient-to-t from-[#0A2440] to-[#061A2F] shadow-[0_-4px_20px_0px_#000] w-[40px] h-[40px] flex items-center justify-center mx-auto absolute top-[98%] left-1/2 -translate-x-1/2 z-[11]"
            // onClick={() => scrollToSection("roadmap")}
          >
            <div className="relative mt-[-20px] flex flex-col items-center space-y-2">
              <div className="flex flex-col items-center">
                <div className="w-3 h-3 border-b-[4px] border-r-[2px] border-[#FFBA08] transform rotate-45 animate-slide relative top-1" />
                <div className="w-3 h-3 border-b-[4px] border-r-[2px] border-[#FFBA08] transform rotate-45 animate-slide" />
              </div>
            </div>
          </div>
          <Image
            src="/CPA_New/mob/intro.png"
            alt="CPA Recruiting firms"
            className="w-full absolute z-10"
            width={360}
            height={55}
            priority
            loading="eager"
            fetchPriority="high"
            sizes="100vw"
            quality={75}
          />
        </div>
      </div>
    </>
  );
};

export default DoctorBannerMobile;
